import React from "react";
import { NavLink } from "react-router-dom";
import { CardActions, CardContent, CardHeader } from "@material-ui/core";

import { StatusMarker } from "../../../statusMarker";
import { SharedAvatars } from "../../../shared-avatars/shared-avatars.component";
import "./info-card.css";

import { StyledCard } from "./info-card.styles";

import { InfoCardProps } from "./info-card.props";
import { BriefType, SharedAvatarsType } from "../../../../constants/types";
import { ApprovalStatus } from "../../../../types/approval-status/approval-status.type";
import { InfoCardOwnerDetails } from "../info-card-owner-template/info-card-owner-details.component";
import { createInfoCardSubheader, createInfoCardTitle } from "../../types/info-card.functions";
import { InfoCardWoOwnerDetails } from "../info-card-wo-owner-details/info-card-wo-owner-details.component";
import { getBriefPageUrl } from "../../../../features/navigation/types/pages.functions";
import { WorkOrderProps } from "../../../../features/brief-list/types/props/work-order.props";

export const InfoCard = ({ briefData, briefType }: InfoCardProps) => {
  const { id, name, ownerName, reviewers, status, resourcetype } = briefData;
  const { contentCreators, executionBriefName } = briefData as WorkOrderProps;

  const hasReviewers = () => reviewers && reviewers.length > 0;
  const numberOfReviewers = () => (reviewers && reviewers.length ? reviewers.length : 0);
  const isWorkOrder = () => briefType === BriefType.WORK_ORDER;
  const isCbOrEb = () => briefType !== BriefType.WORK_ORDER;

  return (
    <StyledCard
      // @ts-expect-error
      component={NavLink}
      to={`${getBriefPageUrl(briefType)}/${id}`}
    >
      <CardHeader
        title={<b>{createInfoCardTitle(name)}</b>}
        subheader={createInfoCardSubheader(briefType, briefData)}
      />

      <CardContent>
        <StatusMarker status={status as ApprovalStatus} />
        <div className="card-text">
          <InfoCardOwnerDetails showIf={isCbOrEb()} owner={ownerName} resourcetype={resourcetype} />
          <InfoCardWoOwnerDetails
            showIf={isWorkOrder()}
            ownerName={ownerName}
            contentCreatorDetails={contentCreators?.map((creator) => creator.userDetails) ?? []}
            executionBriefName={executionBriefName}
          />
        </div>
      </CardContent>
      <CardActions>
        <div className="card-shares">
          <div className="card-share-header">
            <strong>Approvers</strong>{" "}
            <span className="card-share-count">({numberOfReviewers()})</span>
          </div>
          <SharedAvatars
            showIf={hasReviewers()}
            type={SharedAvatarsType.GRID_TYPE}
            people={reviewers!}
          />
        </div>
      </CardActions>
    </StyledCard>
  );
};
